import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectorsIconColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.33325 28.3333L11.6666 36.6666L11.6666 30L21.6666 30L21.6666 26.6666L11.6666 26.6666L11.6666 20L3.33325 28.3333ZM4.99992 13.3333L8.33325 13.3333L8.33325 9.99996L4.99992 9.99996L4.99992 13.3333ZM11.6666 13.3333L14.9999 13.3333L14.9999 9.99996L11.6666 9.99996L11.6666 13.3333ZM18.3333 13.3333L28.3333 13.3333L28.3333 20L36.6666 11.6666L28.3333 3.33329L28.3333 9.99996L18.3333 9.99996L18.3333 13.3333ZM24.9999 30L28.3333 30L28.3333 26.6666L24.9999 26.6666L24.9999 30ZM31.6666 30L34.9999 30L34.9999 26.6666L31.6666 26.6666L31.6666 30Z",
			fill: "#3AC6FF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.99963 13.3332L8.33297 13.3332L8.33297 9.99983L4.99963 9.99983L4.99963 13.3332ZM11.6663 13.3332L14.9996 13.3332L14.9996 9.99983L11.6663 9.99983L11.6663 13.3332ZM18.333 13.3332L28.333 13.3332L28.333 19.9998L36.6663 11.6665L28.333 3.33317L28.333 9.99983L18.333 9.99983L18.333 13.3332Z",
			fill: "#1576B2"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgConnectorsIconColor;
